
import CanvasKeyFrames from 'canvaskeyframes';

var getImageSize = function getImageSize(_ref) {
  var maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      width = _ref.width,
      height = _ref.height;

  if (width >= maxWidth && height >= maxHeight) {
    var widthRatio = width / maxWidth;
    var heightRatio = height / maxHeight;
    var maxRatio = Math.max(heightRatio, widthRatio);
    return {
      width: width / maxRatio,
      height: height / maxRatio
    };
  }

  if (width >= maxWidth && height < maxHeight) {
    var _widthRatio = width / maxWidth;
    return {
      width: width / _widthRatio,
      height: height / _widthRatio
    };
  }

  if (width < maxWidth && height >= maxHeight) {
    var _heightRatio = height / maxHeight;
    return {
      width: width / _heightRatio,
      height: height / _heightRatio
    };
  }

  return {
    width: width,
    height: height
  };
};

export default {
  props: {
    images: {
      type: Array,
      required: true
    },
    frameSequenceContainerStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initKeyFramesOnMounted: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      keyFrames: null,
      loading: true,
      width: '',
      height: ''
    };
  },


  computed: {
    maxWidth: function maxWidth() {
      if (this.frameSequenceContainerStyle.width) {
        return parseInt(this.frameSequenceContainerStyle.width, 10);
      }
      return 200;
    },
    maxHeight: function maxHeight() {
      if (this.frameSequenceContainerStyle.height) {
        return parseInt(this.frameSequenceContainerStyle.height, 10);
      }
      return 200;
    }
  },

  watch: {
    images: {
      handler: function handler(val) {
        var _this = this;

        if (this.initKeyFramesOnMounted) {
          this.loading = true;
          // 清空原有 canvas 元素
          this.$refs['frame-sequence'].innerHTML = '';
          this.loadImages(function (images) {
            _this.$emit('loaded');
            _this.loading = false;
            _this.keyFrames = _this.initKeyFrames(images, 'frame-sequence');
            _this.play();
          }, val);
        }
      }
    },
    deep: true
  },

  mounted: function mounted() {
    var _this2 = this;

    // 非序列帧展示形式不需要 loading
    if (this.initKeyFramesOnMounted === false) {
      this.loading = false;
    }
    if (this.initKeyFramesOnMounted) {
      this.loadImages(function (images) {
        _this2.$emit('loaded');
        _this2.loading = false;
        _this2.keyFrames = _this2.initKeyFrames(images, 'frame-sequence');
        _this2.play();
      });
    }
  },


  methods: {
    loadImages: function loadImages(onLoaded) {
      var _this3 = this;

      var images = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.images;

      var count = 0;
      var innerImages = [];

      var _loop = function _loop(i) {
        var img = new Image();
        // eslint-disable-next-line no-loop-func
        img.onload = function () {
          if (!_this3.width || !_this3.height) {
            var _getImageSize = getImageSize({
              maxWidth: _this3.maxWidth,
              maxHeight: _this3.maxHeight,
              width: img.width,
              height: img.height
            }),
                width = _getImageSize.width,
                height = _getImageSize.height;

            _this3.width = width;
            _this3.height = height;
          }
          img.onload = null;
          innerImages[i] = img;
          count = count + 1;
          if (count === images.length) {
            typeof onLoaded === 'function' && onLoaded(innerImages);
          }
        };
        img.onerror = function () {};
        img.src = images[i];
      };

      for (var i = 0; i < images.length; i++) {
        _loop(i);
      }
    },
    play: function play() {
      this.keyFrames && this.keyFrames.play();
    },
    initKeyFrames: function initKeyFrames(images, ref) {
      if (!this.$refs[ref]) return;
      if (this.$refs[ref].querySelector('canvas')) {
        this.$refs['frame-sequence'].innerHTML = '';
      }
      return new CanvasKeyFrames(this.$refs[ref], 'array', images, {
        fps: 10,
        width: this.width / 2,
        height: this.height / 2
      });
    }
  }
};